import React, { useRef, useState } from "react";
import { Toast } from "primereact/toast";

const buttonStyle = {
  minWidth: "42px",
  height: "42px",
  borderRadius: "14px",
  border: "1px solid rgba(214, 224, 235, 0.92)",
  background: "rgba(255,255,255,0.96)",
  cursor: "pointer",
  fontWeight: 700,
  color: "var(--text-primary)",
};

const CopyInput = ({ value = "" }) => {
  const [copied, setCopied] = useState(false);
  const toast = useRef(null);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.current.show({
        severity: "success",
        summary: "Copied to clipboard",
        life: 1500,
      });
      setTimeout(() => setCopied(false), 1500);
    } catch (error) {
      console.error("Copy failed:", error);
    }
  };

  return (
    <div style={{ display: "flex", gap: "0.7rem", alignItems: "center", width: "100%" }}>
      <Toast ref={toast} />
      <input
        type="text"
        value={value}
        readOnly
        style={{ flex: 1, minHeight: "46px", padding: "0 0.95rem" }}
      />
      <button type="button" onClick={handleCopy} style={buttonStyle}>
        {copied ? "OK" : "Copy"}
      </button>
    </div>
  );
};

export default CopyInput;
